<div class="dialog-wrapper">

  <!-- Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">Initiate Process</h2>

    <button
      mat-icon-button
      class="close-btn"
      (click)="closeDialog()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Form -->
  <form [formGroup]="initiateForm">

    <div class="row g-3 mt-1">

      <!-- Choose Year -->
      <div class="col-12">
          <mat-label class="field-label">Choose Year</mat-label>
        <mat-form-field appearance="outline" class="w-100">
        

          <mat-select formControlName="year">
            <mat-option
              *ngFor="let year of years"
              [value]="year"
            >
              {{ year }}
            </mat-option>
          </mat-select>

          <mat-error
            *ngIf="initiateForm.get('year')?.hasError('required')"
          >
            Year is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Start Date -->
      <div class="col-md-6">
        <mat-label class="field-label">Start Date</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          

          <input
            matInput
            [matDatepicker]="startPicker"
            formControlName="startDate"
          />

          <mat-datepicker-toggle
            matIconSuffix
            [for]="startPicker"
          ></mat-datepicker-toggle>

          <mat-datepicker #startPicker></mat-datepicker>

          <mat-error
            *ngIf="initiateForm.get('startDate')?.hasError('required')"
          >
            Start date is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- End Date -->
      <div class="col-md-6">
        <mat-label class="field-label">End Date</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          

          <input
            matInput
            [matDatepicker]="endPicker"
            formControlName="endDate"
          />

          <mat-datepicker-toggle
            matIconSuffix
            [for]="endPicker"
          ></mat-datepicker-toggle>

          <mat-datepicker #endPicker></mat-datepicker>

          <mat-error
            *ngIf="initiateForm.get('endDate')?.hasError('required')"
          >
            End date is required
          </mat-error>
        </mat-form-field>
      </div>

    </div>

    <!-- Footer -->
    <div class="dialog-footer">

      <button
        mat-stroked-button
        class="btn"
        type="button"
        (click)="closeDialog()"
      >
        Cancel
      </button>

      <button
        mat-flat-button
        class="btn"
        color="primary"
        type="button"
        (click)="initiate()"
      >
        Initiate
      </button>

    </div>

  </form>

</div>